module.exports = __webpack_public_path__ + "static/media/sidebar_lobby_active.172caa55.svg";